import React, { useEffect, useState } from 'react';
const links = [{
  href: '#verhaal',
  label: 'Verhaal'
}, {
  href: '#concept',
  label: 'Concept'
}, {
  href: '#ritueel',
  label: 'Ritueel'
}, {
  href: '#producten',
  label: 'Producten'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed inset-x-0 top-0 z-40 px-4 pt-4 lg:px-8" data-id="element-36" data-mp="2wjfh80jyyqfi">
      <div className={`mx-auto flex h-14 max-w-7xl items-center justify-between rounded-full px-5 transition-[background-color,box-shadow] duration-200 lg:px-7 ${scrolled ? 'bg-sand/85 shadow-[0_1px_0_#D8C9B6,0_8px_24px_-12px_rgba(42,31,24,0.25)] backdrop-blur-md' : 'bg-transparent'}`} data-id="element-37" data-mp="31d0715bese3m">
        <a href="#top" className="font-display text-2xl font-semibold tracking-[0.28em] text-ink" aria-label="AMIRA home" data-id="element-38" data-mp="3fc9oe8bcpe96">
          AMIRA
        </a>
        <nav aria-label="Hoofdnavigatie" className="hidden md:block" data-id="element-39" data-mp="2rl8bir6ksf0n">
          <ul className="flex items-center gap-8 text-sm text-ink/70" data-id="element-40" data-mp="2ro49ugmc55pm">
            {links.map(l => <li key={l.href} data-id="element-41" data-mp="2hnlh0wcsmevk">
                <a href={l.href} className="whitespace-nowrap transition-colors duration-150 hover:text-ink" data-id="element-42" data-mp="2hodfcexryqpj">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <a href="#producten" className="whitespace-nowrap rounded-full bg-ink px-5 py-2 text-sm font-medium text-sand transition-colors duration-150 hover:bg-clay" data-id="element-43" data-mp="3adkbx8do5685">
          Collectie
        </a>
      </div>
    </header>;
}